import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import * as sessionActions from '../actions/session-actions';
import PublicModal from '../components/PublicModal.js';
import ProgressButton from '../components/ProgressButton.js';

import './ForgotPasswordPage.css';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.renderContents = this.renderContents.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.formValid = this.formValid.bind(this);

    this.state = {
      email: ''
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email } = this.state;
    this.props.actions.requestPasswordReset({ email });
  }

  handleInputChange(event) {
    const { target } = event;
    const { value, name } = target;

    // Update the state key of the input's `name` with the new value.
    this.setState({
      [name]: value
    });
  }

  formValid() {
    return this.state.email.length > 0;
  }

  renderContents() {
    let helpText = <p>Enter the email address you used to create your Normal account and we’ll email you a link to reset your password.</p>;

    // Password reset successfully, show message saying to check your email.
    if (this.props.session.resetPassword) {
      return (
        <div>
          <h1>Reset your password</h1>
          <p>Boom! We’ve sent you an email with a link to reset your password.</p>
        </div>
      );
    }

    // Error occurred resetting password, render that out.
    if (this.props.session.resetPasswordError) {
      helpText = <p>We couldn’t find an account with that email. Sorry :’(</p>;
    }

    const formValid = this.formValid();

    return (
      <div>
        <h1 className="ForgotPasswordPage__header">Reset your password</h1>
        {helpText}
        <form className="form LoginForm" disabled={this.props.session.resettingPassword} action="#" onSubmit={this.handleSubmit}>
          <div className="form-group">
            <input className="form-input form-input--dark form-input--fullwidth"
              name="email"
              type="email"
              placeholder="email address"
              onChange={this.handleInputChange}
              disabled={this.props.session.resettingPassword}
              value={this.state.email} />
          </div>

          <ProgressButton type="submit"
            buttonStyle="dark"
            formSubmit={true}
            label="Submit"
            loadingLabel="Submitting..."
            loading={this.props.session.resettingPassword}
            disabled={!formValid || this.props.session.resettingPassword} />
        </form>

        <Link className="muted" to="/login">Remember your password?</Link>
      </div>
    );
  }

  render() {
    return (
      <div className="ForgotPasswordPage">
        <PublicModal centered={false}>
          <div className="col-sm-10 col-sm-push-1 col-lg-6 col-lg-push-3">
            {this.renderContents()}
          </div>
        </PublicModal>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    session: state.session
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage.js